import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(0.25, 0.5),
      backgroundColor: COLORS.neutral.mediumGray,
      color: COLORS.neutral.white,
      borderRadius: 4,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
  { name: 'BadgeOriginal' }
);
